import React, { useEffect, useState } from "react";

import ManagementPageContainer from "../../components/ManagementPageContainer/ManagementPageContainer";
import NotificationList from "../../components/NotificationList.js/NotificationList";
import { getNotExpiredNotification } from "../../http-request/notification";

const NotificationTRE = () => {
  const [notifications, setNotifications] = useState([]);
  useEffect(() => {
    loadNotification();
  }, []);

  const loadNotification = async () => {
    await getNotExpiredNotification().then(({ result }) =>
      setNotifications(result)
    );
  };

  return (
    <ManagementPageContainer title={"Notification"}>
      {notifications.map((notification, key) => {
        return (
          <NotificationList
            key={key}
            {...notification}
         
          />
        );
      })}
    </ManagementPageContainer>
  );
};

export default NotificationTRE;
